import { addOnAddToCartActionHander } from '../cartActionHandler';
import { cartDetailsUrl } from '../currentCart';
import { getAppProps, getProductHandleFromRelativeUrl } from '../utils';
import { getAddOns, sortAddOns } from '../addOnsUtil';
import getCollectionAddOns from '../collectionAddOns';
import { PAGE } from '../domain';
import getCatalogAddOns from '../catalogAddOns';
import renderer, { removeUpsell, renderPlaceholder } from '../renderer';
import errorHandler from '../errorHandler';

export default function cartPage() {
  const { options, addOnsDb } = getAppProps();
  try {
    addOnAddToCartActionHander(true, options);

    jUpsell
      .getJSON(cartDetailsUrl, function(result) {
        try {
          const addOnsInCart = {};
          const addOns = [];
          const addOnsTracker = {};
          if (result.items) {
            for (let i = 0; i < result.items.length; i++) {
              const product = result.items[i];
              const handle = getProductHandleFromRelativeUrl(product.url);
              //if we are treating variants as individual items
              // then use variantId as a tracker otherwise use product handle
              if (options.groupVariants) {
                addOnsInCart[handle] = product;
              } else {
                addOnsInCart[product.variant_id] = product;
              }
            }
            const groupVairantsTracker = options.groupVariants ? {} : null;
            if (!options.disableCartPageProductAddOns) {
              for (let i = 0; i < result.items.length; i++) {
                const product = result.items[i];
                const productAddOns = getAddOns(
                  function() {
                    return addOnsDb[product.product_id];
                  },
                  addOnsDb,
                  addOnsTracker,
                  addOnsInCart,
                  groupVairantsTracker
                );
                addOns.push.apply(addOns, productAddOns);
                const collectionAddOns = getCollectionAddOns(
                  PAGE.Cart,
                  product.product_id,
                  addOnsDb,
                  addOnsTracker,
                  addOnsInCart,
                  groupVairantsTracker
                );
                addOns.push.apply(addOns, collectionAddOns);
              }
            }
            const allProductAddOns = getCatalogAddOns(
              addOnsDb,
              addOnsTracker,
              addOnsInCart,
              groupVairantsTracker
            );
            addOns.push.apply(addOns, allProductAddOns);
            if (groupVairantsTracker) {
              for (let groupedVariant in groupVairantsTracker) {
                addOns.push(groupVairantsTracker[groupedVariant]);
              }
            }
            const sortedAddOns = sortAddOns(addOns);
            if (sortedAddOns.length > 0) {
              renderPlaceholder(PAGE.Cart);
              renderer(sortedAddOns, undefined, PAGE.Cart);
            }
          }
        } catch (err) {
          removeUpsell();
          errorHandler(err);
        }
      })
      .fail(function(xhr) {
        console.log(
          `errors in fetching ${cartDetailsUrl}, StatusCode:${xhr.status}`
        );
      });
  } catch (err) {
    removeUpsell();
    errorHandler(err);
  }
}
